export default __webpack_public_path__ + "static/media/git.c335d524.svg";